import bootBlock, { whenGlobal } from '../../src/js/block-boot';

function initHeroSlider(root, { isEditor }) {
  const block = root.querySelector('.hero-slider');
  const sliderEl = block?.querySelector('.hero-slider__swiper');
  if (!sliderEl || sliderEl.dataset.runtimeReady === 'true') return;
  sliderEl.dataset.runtimeReady = 'true';

  const pauseBtn  = block.querySelector('.hero-slider__pause');
  const pauseIcon = pauseBtn?.querySelector('.hero-slider__pause-icon--pause');
  const playIcon  = pauseBtn?.querySelector('.hero-slider__pause-icon--play');

  whenGlobal(sliderEl.ownerDocument.defaultView, 'Swiper', (Swiper) => {
    const swiper = new Swiper(sliderEl, {
      loop: true,
      autoplay: isEditor ? false : {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 600,
      navigation: {
        prevEl: block.querySelector('.hero-slider__arrow--prev'),
        nextEl: block.querySelector('.hero-slider__arrow--next'),
      },
      pagination: {
        el: block.querySelector('.hero-slider__pagination'),
        clickable: true,
      },
    });

    // Autoplay stays off in the editor, so the toggle has nothing to control.
    if (isEditor) return;

    // ── Pause / play toggle ───────────────────────────────────────────────────
    pauseBtn?.addEventListener('click', () => {
      const isPaused = pauseBtn.getAttribute('aria-pressed') === 'true';

      if (isPaused) {
        swiper.autoplay.start();
        pauseBtn.setAttribute('aria-pressed', 'false');
        pauseBtn.setAttribute('aria-label', pauseBtn.dataset.labelPause);
        if (pauseIcon) pauseIcon.style.display = '';
        if (playIcon)  playIcon.style.display  = 'none';
      } else {
        swiper.autoplay.stop();
        pauseBtn.setAttribute('aria-pressed', 'true');
        pauseBtn.setAttribute('aria-label', pauseBtn.dataset.labelPlay);
        if (pauseIcon) pauseIcon.style.display = 'none';
        if (playIcon)  playIcon.style.display  = '';
      }
    });
  });
}

bootBlock('hero-slider', initHeroSlider);
